import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import styled from "styled-components";
import { Colors } from "../../config";
import OnBoardingHeader from "./OnBoardingHeader";
import OnBoradingSubHeader from "./OnBoradingSubHeader";
import OnBoardingIcon from "../../assets/Icons/OnboardingIcon";

const FirstCarousal = () => {
  return (
    <BoxContainer>
      <ImageContainer>
        <OnBoardingIcon />
      </ImageContainer>
      <OnBoardingHeader header="Plan a Trip" />
      <SubTextContainer>
        <OnBoradingSubHeader
          color={Colors.brandOne}
          header="Welcome to PowerFLY!"
        />
        <br></br>
        <OnBoradingSubHeader
          color={Colors.ashBlue}
          header="Our app simplifies the entire process of planning and managing your trip. You'll be able to view your travel entitlements and start creating your itinerary in no time."
        />
      </SubTextContainer>
    </BoxContainer>
  );
};
const BoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  padding: 20px;
  align-items: center;
  border-radius: 1.25rem;
  /* @media only screen and (max-width: 478px) {
    width: 15.625rem;
  } */
  /* max-height: 42rem; */
  margin-left: 40rem;
  margin-right: 40rem;
`;

const ImageContainer = styled.div`
  align-items: center;
  justify-content: center;
  width: 20rem;
  height: 17.732rem;
  margin-top: 1rem;
  margin-bottom: 3.393rem;

  /* @media only screen and (max-width: 478px) {
    width: 15.625rem;
  } */
  /* object-fit: contain;
  animation-name: spin; 
  animation-duration: 2s; 
  animation-iteration-count: infinite; 
  animation-timing-function: linear;
  @keyframes spin {
    from {
      transform: rotates(-20deg); 
    }
    to {
      transform: rotate(20deg); 
    }
  } */
`;
const SubTextContainer = styled.div`
  /* display: flex; */
  flex-direction: column;
  margin-bottom: 2rem;
  max-width: 28rem;
  @media only screen and (max-width: 478px) {
    width: 20rem;
  }
`;
export default FirstCarousal;
